export default {"src":"/_next/static/media/kodex-draw.94c1d6a0.gif","height":659,"width":1280};